import React from 'react';

const WhyUs = () => {
  const reasons = [
    {
      title: "Profesyonel Ekip",
      description: "Cihangir Nakliyat olarak, taşıma sektöründe uzmanlaşmış, deneyimli ve sürekli eğitim alan bir ekibe sahibiz. Personelimiz, nakliye sürecinin her aşamasında titizlikle çalışarak, eşyalarınızın güvenliğini ve bütünlüğünü korumak için özel teknikler kullanmaktadır. Tüm çalışanlarımız, müşteri memnuniyetini en üst düzeyde tutarak, size saygılı ve profesyonel bir hizmet sunmayı ilke edinmiştir.",
      icon: (
        <svg className="w-12 h-12 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      )
    },
    {
      title: "Güvenilir Hizmet",
      description: "15 yılı aşkın süredir sektörde edindiğimiz güven, iş etiğimizin ve kalite standartlarımızın bir yansımasıdır. Şeffaf fiyatlandırma politikamız, zamanında teslim taahhüdümüz ve eşyalarınıza karşı gösterdiğimiz özen, müşterilerimizin bize olan güveninin temelini oluşturur. Cihangir Nakliyat olarak, her taşıma işleminde aynı hassasiyeti göstererek, sizin için değerli olan her şeyin güvenliğini sağlıyoruz.",
      icon: (
        <svg className="w-12 h-12 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      )
    },
    {
      title: "Modern Teknoloji",
      description: "Nakliyat sektöründeki en son teknolojik gelişmeleri yakından takip ederek, hizmet kalitemizi sürekli yükseltiyoruz. Özel asansör sistemlerimiz, profesyonel paketleme materyallerimiz ve modern araç filomuz ile taşınma sürecinizi kolaylaştırıyoruz. Dijital envanter yönetimi sayesinde eşyalarınızın takibini titizlikle yapıyor, GPS teknolojileriyle sevkiyat sürecini anlık olarak izliyoruz. Müşterilerimize sunduğumuz teknolojik çözümlerle, taşınma deneyimini daha güvenli ve verimli hale getiriyoruz.",
      icon: (
        <svg className="w-12 h-12 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      )
    },
    {
      title: "Müşteri Memnuniyeti",
      description: "Hizmet politikamızın merkezinde müşteri memnuniyeti yer almaktadır. Her müşterimizin özel ihtiyaçlarını anlayarak, kişiselleştirilmiş çözümler sunuyoruz. Taşınma öncesi detaylı planlama, süreç boyunca sürekli iletişim ve taşınma sonrası takip hizmetlerimizle, sizlere kesintisiz bir destek sağlıyoruz. Müşteri geri bildirimlerini dikkatle değerlendirerek, hizmet kalitemizi sürekli iyileştiriyoruz. Cihangir Nakliyat'ı tercih eden her müşterimizin yüzündeki memnuniyet, başarımızın en değerli göstergesidir.",
      icon: (
        <svg className="w-12 h-12 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
        </svg>
      )
    }
  ];

  const additionalFeatures = [
    {
      title: "Sigortalı Taşımacılık",
      description: "Tüm nakliye süreçlerimizde eşyalarınız profesyonel nakliyat sigortası kapsamındadır. Bu sayede olası risklere karşı tam koruma sağlıyoruz."
    },
    {
      title: "Sürdürülebilir Hizmet",
      description: "Çevre dostu paketleme malzemeleri ve verimli rota planlaması ile karbon ayak izimizi azaltarak, doğaya saygılı bir hizmet sunuyoruz."
    },
    {
      title: "Özel Çözümler",
      description: "Antika eşyalar, sanat eserleri veya özel dikkat gerektiren eşyalarınız için özel taşıma protokolleri uyguluyoruz."
    },
    {
      title: "Tam Zamanlı Destek",
      description: "Taşınma sürecinizde 7/24 ulaşabileceğiniz müşteri destek hattımız ile sorularınıza anında yanıt veriyoruz."
    }
  ];

  return (
    <div>
      {/* Sayfa Başlığı Banner */}
      <div className="bg-primary text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-4xl font-bold">Neden Biz?</h1>
          <p className="mt-4 text-xl">Farkımızı Keşfedin</p>
        </div>
      </div>

      {/* Kurumsal Giriş Bölümü */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="section-title mb-8">Neden Cihangir Nakliyat?</h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Cihangir Nakliyat olarak, 15 yılı aşkın sektör deneyimimizle taşımacılık alanında güvenilir bir çözüm ortağı olmaktan gurur duyuyoruz. Her taşınma, yeni bir başlangıcın hikâyesidir ve biz bu hikâyenin stressiz, güvenli ve profesyonel bir şekilde yazılmasına katkıda bulunuyoruz.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Müşteri odaklı yaklaşımımız, modern teknolojik altyapımız ve alanında uzman ekibimizle, taşınma sürecinin her aşamasında yanınızda olarak, size değer katan hizmetler sunuyoruz. Bizim için her eşya değerlidir ve her müşteri özeldir. Bu anlayışla, nakliyat sektöründe standartları yükseltmeye ve sizlere en iyi hizmeti sunmaya devam ediyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Ana Değerler Grid */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <h2 className="section-title text-center mb-12">Temel Değerlerimiz</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {reasons.map((reason, index) => (
              <div 
                key={index}
                className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow"
              >
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    {reason.icon}
                  </div>
                  <div className="ml-6">
                    <h3 className="text-xl font-semibold text-primary mb-3">
                      {reason.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      {reason.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Ek Özellikler Bölümü */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <h2 className="section-title text-center mb-12">Fark Yaratan Hizmetlerimiz</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {additionalFeatures.map((feature, index) => (
              <div 
                key={index}
                className="p-6 bg-gray-50 rounded-lg border border-gray-200 hover:border-primary transition-colors"
              >
                <h3 className="text-lg font-semibold text-primary mb-3">{feature.title}</h3>
                <p className="text-gray-700">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Kurumsal Taahhüdümüz */}
      <section className="py-16 bg-primary bg-opacity-5">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="section-title mb-6">Kurumsal Taahhüdümüz</h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Cihangir Nakliyat olarak, her zaman en yüksek kalite standartlarında hizmet vermeyi ve müşteri memnuniyetini ön planda tutmayı taahhüt ediyoruz. Şeffaflık, dürüstlük ve profesyonellik ilkelerimiz doğrultusunda, sizlere güvenilir ve sorunsuz bir taşınma deneyimi sunmak için çalışıyoruz.
            </p>
            <div className="flex justify-center">
              <a 
                href="tel:+905393801469" 
                className="btn-primary"
              >
                Hemen Ara
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* İstatistikler */}
      <section className="bg-gray-50 py-16">
        <div className="container-custom">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-primary mb-2">15+</div>
              <div className="text-gray-700">Yıllık Deneyim</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-primary mb-2">5000+</div>
              <div className="text-gray-700">Başarılı Taşıma</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-primary mb-2">81</div>
              <div className="text-gray-700">İl Genelinde Hizmet</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-primary mb-2">%98</div>
              <div className="text-gray-700">Müşteri Memnuniyeti</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyUs; 